/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import { graphql, withApollo } from 'react-apollo';
import { compose, mapProps } from 'recompose';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { getCurrentUser as getCurrentUserSelector } from 'selectors/user/selector';
import { getIdFromUrlParams } from 'selectors/assessment/selector';
import { showInfoMessage } from 'components/common/Alert/Alert';

import {
  onAssessmentEvent as onAssessmentEventSub,
  getCurrentUser as getCurrentUserQuery,
  updateAssessmentEvent as updateAssessmentEventMut,
  updateActiveUsers as updateActiveUsersMut,
  updateAssessmentStatus as updateAssessmentStatusMut
} from 'graphql/operations';
import { StatusTypes, EventTypes } from 'utils/constants';

export const AssessmentSubscriber = props => {
  const { currentUser, assessmentEvent, apolloClient, showActionsTriggeredInfo } = props;
  const { t } = useTranslation();

  useEffect(() => {
    if (assessmentEvent) {
      const { eventData } = assessmentEvent;
      if (currentUser.email !== eventData.user.email) {
        switch (assessmentEvent.eventType) {
          case EventTypes.TEXT_FIELD_TYPING: {
            apolloClient
              .mutate({
                mutation: updateAssessmentEventMut,
                variables: {
                  fieldId: eventData.textField.id,
                  user: eventData.user,
                  action: eventData.action,
                  eventType: assessmentEvent.eventType,
                  eventData: {},
                  eventTime: eventData.eventTime
                },
                refetchQueries: ['getLatestAssessmentEventById'],
                awaitRefetchQueries: true
              })
              .catch(mError => {
                console.error('updateAssessmentEvent Mutation error', mError);
              });
            break;
          }
          case EventTypes.VALUE_CHANGE: {
            apolloClient
              .mutate({
                mutation: updateAssessmentEventMut,
                variables: {
                  fieldId: eventData.field.id,
                  user: eventData.user,
                  action: 'value-changed',
                  eventType: assessmentEvent.eventType,
                  eventData: {},
                  eventTime: eventData.eventTime
                },
                refetchQueries: ['getLatestAssessmentEventById'],
                awaitRefetchQueries: true
              })
              .catch(mError => {
                console.error('Mutation error', mError);
              });
            break;
          }
          case EventTypes.ACCESS_ASSESSMENT: {
            apolloClient
              .mutate({
                mutation: updateActiveUsersMut,
                variables: {
                  assessmentId: assessmentEvent.assessmentId,
                  user: eventData.user,
                  action: eventData.assessmentInteraction
                }
              })
              .catch(mError => {
                console.error('Mutation error', mError);
              });
            break;
          }
          case EventTypes.ASSESSMENT_STATUS_CHANGE: {
            apolloClient
              .mutate({
                mutation: updateAssessmentStatusMut,
                variables: {
                  assessmentId: assessmentEvent.assessmentId,
                  status: eventData.assessment.status
                }
              })
              .catch(mError => {
                console.error('Mutation error', mError);
              });

            if (eventData.assessment.status === StatusTypes.SUBMITTED) {
              showInfoMessage(t('assessment.simultaneousEdit.submitted'), {
                autoHideDuration: 3000
              });
            }
            break;
          }
          case EventTypes.DDE_ACTIONS_TRIGGERED: {
            showActionsTriggeredInfo(true, eventData.hasRequired);
            showInfoMessage(t('assessment.simultaneousEdit.ddeEditsMessage', { name: `${eventData.user.firstName} ${eventData.user.lastName}` }), {
              autoHideDuration: 10000
            });
            break;
          }
          default: {
            console.error('Unexpected event type:', assessmentEvent.eventType);
          }
        }
      }
    }
  }, [assessmentEvent]);

  return null;
};

AssessmentSubscriber.propTypes = {
  // TODO: Fix this...
  /* eslint-disable react/forbid-prop-types */
  apolloClient: PropTypes.object.isRequired,
  currentUser: PropTypes.object.isRequired,
  assessmentEvent: PropTypes.object
  /* eslint-enable react/forbid-prop-types */
};

export const AssessmentSubscriberHOC = compose(
  withApollo,
  withRouter,
  graphql(getCurrentUserQuery, { name: 'getCurrentUser' }),
  graphql(onAssessmentEventSub, {
    name: 'onAssessmentEvent',
    options: props => ({
      variables: {
        assessmentId: getIdFromUrlParams(props)
      }
    })
  }),
  mapProps(props => ({
    apolloClient: props.client,
    // assessmentId: getAssessmentIdFromUrlParams(props),
    // assessmentSubscription: props.onAssessmentEvent,
    assessmentEvent: props.onAssessmentEvent.onAssessmentEvent,
    currentUser: getCurrentUserSelector(props),
    showActionsTriggeredInfo: props.showActionsTriggeredInfo
  }))
);

export default AssessmentSubscriberHOC(AssessmentSubscriber);
